module.exports = __webpack_public_path__ + "static/media/Simple UI@2x.aa4e45e5.png";